// [xleaders] XO-15 — tên thật từ Twenty CRM hiện cạnh tên kênh (Zalo/Facebook chỉ có nickname).
//
// Bản chụp `twenty_name` do panel CRM ghi vào contact mỗi lần nó đọc Person. KHÔNG gọi CRM ở đây:
// danh sách hội thoại vẽ hàng chục dòng một lúc.
//
// Một nguồn quy tắc duy nhất cho cả ba chỗ vẽ tên (thẻ hội thoại thường, thẻ mở rộng, header) để
// ba chỗ đó không trôi khỏi nhau.
export const crmContactName = contact => {
  const channelName = (contact?.name ?? '').trim();
  const crmName = (
    contact?.additional_attributes?.external?.twenty_name ?? ''
  ).trim();

  if (!crmName) return { name: channelName, crmName: '' };
  if (!channelName) return { name: crmName, crmName: '' };
  if (channelName.toLowerCase() === crmName.toLowerCase()) {
    return { name: channelName, crmName: '' };
  }

  return { name: channelName, crmName };
};

export const crmContactDisplayName = contact => {
  const { name, crmName } = crmContactName(contact);

  return crmName ? `${name} (${crmName})` : name;
};
